import $ from "jquery";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CircularFileDetails } from "../../actions/Circular";
import CONSTANT from "../../constant";
import { getCookie, getStorage } from "../../utils";

export default class CircularFileDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileCode: props.match.params.fileCode,
      ud: getCookie(CONSTANT.cookie.userDetail),
      permissions: getStorage(CONSTANT.cookie.permissions),
      detail: undefined,
      comments: undefined,
      showAddComment: false,
      showLoader: false,
      showTimeLineModal: false,
      timeLineDetails: null,
      visibleParkedFile: false,
      attachedParkedFiles: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.fileDetail;
    const { fileCode } = this.state;

    CircularFileDetails(fileCode).then((res) => {
      this.setState({ ...this.state, detail: res.result });
    });
  }

  onPrint = (e) => {
    const mainSection = $("#main_container");
    let html = mainSection.html();

    const style = `

        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
        <style type="text/css">
         
        body{
            font-size:16px;
        }

        .card-body{
            border-bottom: 2px dotted gray;
        }
        
        @page{
            size:A4,
            margin-top: 2cm;
            margin-bottom: 2cm;
            margin-left:6cm;
            margin-right:1.5cm;
        }
        
        @media print {
            body
            {
                font-size:15.5pt;
            }
            .print-btn{
                visibility:hidden;
            }
        }
        </style> `;

    let myWindow = window.open("", "", "width=800,height=600");

    myWindow.document.write(`${style}
    <button className="print-btn float-right" onclick="window.print()">Print Now</button>
    </div><div className="fluid-container">${html}<br/>
   `);

    myWindow.focus();
  };

  render() {
    const { detail } = this.state;

    return (
      <React.Fragment>
        <div className="d-flex justify-between  ">
          <div>
            <button
              style={{ fontSize: "20px" }}
              onClick={() => {
                this.onPrint();
              }}
              className="btn btn-sm btn-link float-right"
            >
              <i style={{ fontSize: "20px" }} className="fa fa-print" /> Print
            </button>
          </div>

          <div>
            <Link
              to={CONSTANT.component.circularList.url}
              className="btn btn-sm btn-link float-right"
            >
              <h2 style={{ fontSize: "20px" }}> Go Back </h2>
            </Link>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2 px-0"></div>

            <div className="col-md-12 p-5 main_file" id="main_container">
              <div className="d-flex   flex-column justify-center align-items-center ">
                <div>
                  {detail != undefined && (
                    <p className="h4">{detail[0].title}</p>
                  )}
                </div>

                {detail != undefined && detail.length > 0 && (
                  <div>
                    {" "}
                    <p>{detail[0].Keyword}</p>{" "}
                  </div>
                )}

                {detail != undefined &&
                  detail.length > 0 &&
                  detail.map((item, index) => {
                    if (item.path) {
                      let downloadURL = `${process.env.REACT_APP_BASE_URL}get-circular-file/?q=${item.path}`;
                      return (
                        <div>
                          <a
                            href={downloadURL}
                            target="_blank"
                            key={index}
                            className="badge badge-primary m-1 p-2"
                          >
                            <i className="fa fa-arrow-circle-o-down" />
                            {item.originalFileName}
                          </a>
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
